import { addToast } from '@/core/redux/slices/toast-slice';
import { ToastType } from '@/core/types/enums';
import { AppDispatch } from '@/core/redux/store';

interface ToastPayload {
  type: ToastType;
  title: string;
  description?: string;
}

/**
 * Toast service for use in sagas and async operations
 * Usage in saga: toastService(dispatch).showSuccess('Success message')
 */
export const toastService = (dispatch: AppDispatch) => ({
  showSuccess: (title: string, description?: string) => {
    dispatch(addToast({ type: 'success', title, description }));
  },
  showError: (title: string, description?: string) => {
    dispatch(addToast({ type: 'error', title, description }));
  },
  showWarning: (title: string, description?: string) => {
    dispatch(addToast({ type: 'warning', title, description }));
  },
  show: (payload: ToastPayload) => {
    dispatch(addToast(payload));
  },
});

export type ToastService = ReturnType<typeof toastService>;
